<template>
  <div class="dialog-view">
    <div class="dialog">
      <h1 style="color:red">注销时请注意！！</h1>
      <h3>注销账号后，您将永久失去此账号的账号信息、订单记录，且无法恢复，请谨慎操作</h3>

      <div class="btns">
        <button @click="logout">确定</button>
        <button class="cancel" @click="close">取消</button>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {};
  },
  methods: {
    logout() {
        this.$emit('logout')
    },
    close() {
        this.$emit('close')
    },
  },
};
</script>
<style scoped lang='less'>
.dialog-view {
  width: 100%;
  height: 100vh;
  // 半透明背景
  background: rgba(0, 0, 0, 0.5);

  position: fixed;
  top: 0;
  z-index: 12;
  left: 0;
  .dialog {
    width: 500px;
    height: 230px;
    background: #fff;
    border-radius: 10px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 20px 20px 20px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    h1{
      text-align: center;
      font-size: 26px;
      margin-bottom: 20px;
    }
    h3 {
      text-align: center;
    }
    .btns {
      display: flex;
      justify-content: center;
      margin-top: 80px;
      .cancel {
        background: gray !important;
      }
      button {
        padding: 5px 10px;
        margin: 0 10px;
        border: none;
        max-width: 100px;
        border-radius: 5px;
        background: #409eff;
        color: #fff;
        cursor: pointer;
        &:hover {
          background: #66b1ff;
        }
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/cancel-dialog.vue